module.exports = __webpack_public_path__ + "img/1501929208.c21ce888.jpg";